import React, { FC } from 'react';
import './App.css';
import { Header } from './components/header';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AscentinelPath } from './components/ascentinel-path';
import { Missions } from './components/missions';
import { Stats } from './components/stats';
import { CreateMissionForm } from './components/create-mission-form';
import { MissionDetails } from './components/mission-details';
import { LevelUp } from './components/lvl-up';
import { CreateGoalForm } from './components/create-goal-form';
import { GoalDetails } from './components/goal-details';
import { ProfilePage } from './components/profile-page';
import { CompHistory } from './components/history';

export const App: FC = () => {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <AscentinelPath />,
    },
    {
      path: "/missions",
      element: <Missions />,
    },
    {
      path: "/missions/:id",
      element: <MissionDetails />,
    },
    {
      path: "/stats",
      element: <Stats />,
    },
    {
      path: "/create-mission",
      element: <CreateMissionForm />,
    },
    {
      path: "/lvl-up",
      element: <LevelUp />,
    },
    {
      path: "/create-goal",
      element: <CreateGoalForm />,
    },
    {
      path: "/goals/:id",
      element: <GoalDetails />,
    },
    {
      path: "/me",
      element: <ProfilePage />,
    },
    {
      path: "/history",
      element: <CompHistory />,
    }
  ])

  return (
    <div className="App">
      <Header />
      <RouterProvider router={router} />
    </div>
  );
}